export function dealLineToRow(l, dealId, idx) {
  const num = (v) => (v === '' || v == null ? null : parseFloat(v));
  return {
    id: l.id,
    affaire_id: dealId,
    ordre: idx,
    nom: l.nom || null,
    facturation: l.facturation || 'forfait_brique',
    tjm: num(l.tjm),
    jours_min: num(l.jours_min),
    jours_max: num(l.jours_max),
    budget_min: num(l.budget_min),
    budget_max: num(l.budget_max),
    budget_vendu: num(l.budget_vendu),
    jours_vendus: num(l.jours_vendus),
    unite_vendu: l.unite_vendu || 'jours',
    nb_devs_estime: num(l.nb_devs_estime),
    nb_devs_vendu: num(l.nb_devs_vendu),
    tjm_vendu: num(l.tjm_vendu),
    engagement_mois_estime: num(l.engagement_mois_estime),
    engagement_mois_vendu: num(l.engagement_mois_vendu),
    heures_estime: num(l.heures_estime),
    heures_unite_estime: l.heures_unite_estime || 'heures_mois',
    taux_horaire_estime: num(l.taux_horaire_estime),
    heures_vendu: num(l.heures_vendu),
    heures_unite_vendu: l.heures_unite_vendu || 'heures_mois',
    taux_horaire_vendu: num(l.taux_horaire_vendu),
    montant_mensuel: num(l.montant_mensuel),
    montant_mensuel_estime: num(l.montant_mensuel_estime),
    correctif_qte: num(l.correctif_qte),
    correctif_unite: l.correctif_unite || 'heures_mois',
    evolutif_qte: num(l.evolutif_qte),
    evolutif_unite: l.evolutif_unite || 'jours_an',
    date_debut_prevue: l.date_debut_prevue || null,
    date_fin_prevue: l.date_fin_prevue || null,
    annulee: !!l.annulee,
  };
}
